<template>
  <footer class="footer">
    <div class="nav-section">
      <ul class="nav">
        <li class="nav__item" v-for="(item, i) in $parent.nav" :key="i">
          <router-link :to="item.link">
            {{ item.title }}
          </router-link>
        </li>
      </ul>
      <ul class="nav">
        <li class="nav__item" v-for="page in staticPages" :key="page.id">
          <router-link :to="`/${page.slug ? page.slug : page.id}`">
            {{ page.title }}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <div class="text" v-if="$parent.footerRequisites">
            <div class="desc">{{ $parent.footerRequisites }}</div>
          </div>
        </div>
        <div class="center">
          <ul class="list">
            <li class="item" v-if="$parent.footerSupportEmail">
              <div class="desc">Support:</div>
              <div class="desc">
                <b>{{ $parent.footerSupportEmail }}</b>
              </div>
            </li>
          </ul>
        </div>
        <div class="right">
          <div
            class="desc"
            v-if="$parent.socialLinks && $parent.socialLinks.length"
          >
            Social media:
          </div>
          <div
            class="socials"
            v-if="$parent.socialLinks && $parent.socialLinks.length"
          >
            <a
              v-for="link in $parent.socialLinks"
              :href="link.link"
              class="item"
              :key="link.img"
            >
              <div class="image">
                <img v-if="link.img" :src="link.img" class="img" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-section">
      <div class="wrapper">
        <div class="right">
          <div class="desc" v-if="$parent.footerCopyright">
            © {{ new Date().getFullYear() }} {{ $parent.footerCopyright }}
          </div>
        </div>
        <div class="left">
          <ul class="list">
            <li
              class="item"
              v-for="(image, index) in footerPaymentImages"
              :key="paymentImageUrl(image) + index"
            >
              <img
                :src="paymentImageUrl(image)"
                class="img"
                :style="paymentImageStyle(image)"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  components: {},
  props: {
    socialLinks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("staticPages", ["staticPages"]),
    ...mapGetters("app", ["footerPaymentImages"]),
  },
  methods: {
    paymentImageUrl(image) {
      const url = typeof image === "string" ? image : image.url;

      if (!url) return "";
      if (/^https?:\/\//.test(url) || /^data:/.test(url)) return url;

      return this.$parent.appDomain + url;
    },
    paymentImageStyle(image) {
      const height = typeof image === "object" ? image.height : null;

      if (!height) return {};

      return {
        height: `${height}px`,
        width: "auto",
      };
    },
  },
  mounted() {},
};
</script>
